import { Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardMedia,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
  TextField,
  MenuItem,
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { useSelector } from 'react-redux';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function EditProfile({ profile, setEditMode, getProfile, setImage }) {
  const accountData = JSON.parse(localStorage.getItem('profile'));
  const { accType, role } = useSelector((state) => state.user.userInfo);
  const admin = accType === 'SUPER_ADMIN' || accType === 'SUB_ADMIN';

  const superAdmin = accType === 'SUPER_ADMIN';

  const AdminSchema = Yup.object().shape({
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .max(20, 'Password must be at most 20 characters'),
  });

  const formik = useFormik({
    initialValues: {
      id: profile?._id || '',
      fullname: profile?.fullname || '',
      email: profile?.email || '',
      description: profile?.description || '',
      designation: profile?.designation || '',
      // accType: profile?.accType || '',
      password: '',
      profilePic: '',
    },
    validationSchema: AdminSchema,
    onSubmit: async () => {
      try {
        const res = await axios.put(`${process.env.REACT_APP_API_URL}/admin/profile`, values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        console.log(res);
        // localStorage.setItem('profile', JSON.stringify(res.data.data));
        console.log(res.data);
        window.location.reload();
        toast(res.data.message);
        setEditMode(false);
        getProfile();
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;

  useEffect(() => {
    if (values.profilePic) {
      setImage(URL.createObjectURL(values.profilePic));
    }
  }, [values.profilePic]);

  return (
    <Grid item xs={12} sm={6} md={7} lg={8} padding={2}>
      <Stack direction="column" alignItems="center" justifyContent="start" sx={{ height: '100%' }} marginLeft={2}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" margin={1} sx={{ width: '100%' }}>
          <Typography variant="h4" gutterBottom>
            EDIT ACCOUNT DETAILS
          </Typography>
        </Stack>

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {admin && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    size="small"
                    label="Full Name"
                    fullWidth
                    sx={{ width: '100%' }}
                    {...getFieldProps('fullname')}
                    error={Boolean(touched.fullname && errors.fullname)}
                    helperText={touched.fullname && errors.fullname}
                  />
                </Grid>
              )}
              {admin && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="email"
                    size="small"
                    label="Email"
                    fullWidth
                    sx={{ width: '100%' }}
                    {...getFieldProps('email')}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Grid>
              )}
              {/* <Grid item xs={12} sm={6}>
                <TextField
                  select
                  size="small"
                  label="Account Type"
                  fullWidth
                  sx={{ width: '100%' }}
                  {...getFieldProps('accType')}
                  error={Boolean(touched.accType && errors.accType)}
                  helperText={touched.accType && errors.accType}
                >
                  <MenuItem value="SUB_ADMIN">SUB ADMIN</MenuItem>
                  <MenuItem value="SUPER_ADMIN">SUPER ADMIN</MenuItem>
                </TextField>
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <TextField
                  type="password"
                  size="small"
                  label="Password"
                  fullWidth
                  sx={{ width: '100%' }}
                  {...getFieldProps('password')}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  type="file"
                  size="small"
                  label="Profile Picture"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: 'image/jpeg, image/jpg, image/png' }}
                  name="profilePic"
                  onChange={(event) => formik.setFieldValue('profilePic', event.target.files[0])}
                />
              </Grid>
              {superAdmin && (
                <Grid item xs={12} sm={6}>
                  <TextField
                    type="text"
                    size="small"
                    label="Designation"
                    fullWidth
                    sx={{ width: '100%' }}
                    {...getFieldProps('designation')}
                    error={Boolean(touched.designation && errors.designation)}
                    helperText={touched.designation && errors.designation}
                  />
                </Grid>
              )}
              {superAdmin && (
                <Grid item xs={12} sm={6}> 
                  <TextField
                    type="text"
                    size="small"
                    label="Description"
                    fullWidth
                    sx={{ width: '100%' }}
                    {...getFieldProps('description')}
                    error={Boolean(touched.description && errors.description)}
                    helperText={touched.description && errors.description}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <Stack direction="row" sx={{ width: '100%' }} spacing={2} justifyContent="end">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => {
                      setEditMode(false);
                      setImage(null);
                    }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
                    Submit
                  </LoadingButton>
                </Stack>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </Stack>
    </Grid>
  );
}
